export default __webpack_public_path__ + "static/media/redhook.d2a40523.png";